import { Circle, Rect } from 'react-konva';
import { useSheetCorrection } from './SheetCorrectionProvider';

const markerColors = ['grey', 'black', 'green', 'red', 'yellow'];

function SheetCorrectionRow(props) {
	const { lattice, rowIdx } = props;
	const { changeCursor, data, setData } = useSheetCorrection();
	const size = lattice.cols[1].x - lattice.cols[0].x;
	const currentModified = data.find(d => d.examineeAnswerId === lattice.vizsgazo_valasz_id);
	const isCircle = lattice.supervised || currentModified;

	const handleClick = (valaszId, colIdx) => {
		const valasz = {
			funcType: 'none',
			examineeAnswerId: lattice.vizsgazo_valasz_id,
			answer: colIdx,
			answerId: valaszId,
			rowId: rowIdx,
			colIdList: [colIdx]
		};
		if (data.findIndex(d => d.examineeAnswerId === lattice.vizsgazo_valasz_id) > -1) {
			setData(
				data.map(d => {
					if (d.examineeAnswerId === lattice.vizsgazo_valasz_id) return valasz;
					return d;
				})
			);
		} else {
			setData([...data, valasz]);
		}
	};

	if (currentModified) {
		const valid = lattice.cols[currentModified.answer].helyes;
		return (
			<>
				<Circle x={lattice.cols[0].x - size * 3} y={lattice.cols[0].y} width={size / 2} height={size / 2} fill={valid ? 'green' : 'red'} offsetX={(size / 4) * -1} offsetY={(size / 4) * -1} />
				{lattice.cols.map((col, colIdx) =>
					currentModified.answer === colIdx ? (
						<Circle
							key={col.valasz_id}
							x={col.x}
							y={col.y}
							width={size}
							height={size}
							stroke={col.helyes ? 'green' : 'red'}
							strokeWidth={2}
							offsetX={(size / 2) * -1}
							offsetY={(size / 2) * -1}
							onPointerEnter={() => changeCursor('pointer')}
							onPointerLeave={() => changeCursor('default')}
							onPointerClick={e => handleClick(col.valasz_id, colIdx)}
						/>
					) : (
						<Rect
							key={col.valasz_id}
							x={col.x}
							y={col.y}
							width={size}
							height={size}
							onPointerEnter={() => changeCursor('pointer')}
							onPointerLeave={() => changeCursor('default')}
							onPointerClick={e => handleClick(col.valasz_id, colIdx)}
						/>
					)
				)}
			</>
		);
	}
	return (
		<>
			{isCircle ? (
				<Circle x={lattice.cols[0].x - size * 3} y={lattice.cols[0].y} width={size / 2} height={size / 2} fill={markerColors[lattice.marker]} offsetX={(size / 4) * -1} offsetY={(size / 4) * -1} />
			) : (
				<Rect x={lattice.cols[0].x - size * 3} y={lattice.cols[0].y} width={size / 2} height={size / 2} fill={markerColors[lattice.marker]} />
			)}
			{lattice.cols.map((col, colIdx) =>
				isCircle ? (
					<Circle
						key={col.valasz_id}
						x={col.x}
						y={col.y}
						width={size}
						height={size}
						stroke={markerColors[col.marker]}
						strokeWidth={2}
						strokeEnabled={col.marker > 1}
						offsetX={(size / 2) * -1}
						offsetY={(size / 2) * -1}
						onPointerEnter={() => changeCursor('pointer')}
						onPointerLeave={() => changeCursor('default')}
						onPointerClick={e => handleClick(col.valasz_id, colIdx)}
					/>
				) : (
					<Rect
						key={col.valasz_id}
						x={col.x}
						y={col.y}
						width={size}
						height={size}
						stroke={markerColors[col.marker]}
						strokeWidth={2}
						strokeEnabled={col.marker > 1}
						onPointerEnter={() => changeCursor('pointer')}
						onPointerLeave={() => changeCursor('default')}
						onPointerClick={e => handleClick(col.valasz_id, colIdx)}
					/>
				)
			)}
		</>
	);
}

export default SheetCorrectionRow;
